import { render } from "./FileUploaderList.vue?vue&type=template&id=35aeca68"
import script from "./FileUploaderList.vue?vue&type=script&lang=js"
export * from "./FileUploaderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__